import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Profil from '@/views/Profil.vue'
import Tupoksi from '@/views/Tupoksi.vue'
import Struktur from '@/views/Struktur.vue'
import Visi from '@/views/Visi.vue'
import Pejabat from '@/views/Pejabat.vue'
import Berita from '@/views/Berita.vue'
import DetailBerita from '@/views/DetailBerita.vue'
import Pengumuman from '@/views/Pengumuman.vue'
import Dokumen from '@/views/Dokumen.vue'
import Foto from '@/views/Foto.vue'
import Video from '@/views/Video.vue'
import Sekretariat from '@/views/Sekretariat.vue'
import CiptaKarya from '@/views/CiptaKarya.vue'
import BinaMarga from '@/views/BinaMarga.vue'
import Sda from '@/views/Sda.vue'
import JasaKonstruksi from '@/views/JasaKonstruksi.vue'
import TataRuang from '@/views/TataRuang.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/profil',
    name: 'profil',
    component: Profil
  },
  {
    path: '/tupoksi',
    name: 'tupoksi',
    component: Tupoksi
  },
  {
    path: '/struktur',
    name: 'struktur',
    component: Struktur
  },
  {
    path: '/visi',
    name: 'visi',
    component: Visi
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: Sekretariat
  },
  {
    path: '/pejabat',
    name: 'pejabat',
    component: Pejabat
  },
  {
    path: '/berita',
    name: 'berita',
    component: Berita
  },
  {
    path: '/detail_berita',
    name: 'detail_berita',
    component: DetailBerita
  },
  {
    path: '/cipta_karya',
    name: 'cipta_karya',
    component: CiptaKarya
  },
  {
    path: '/bina_marga',
    name: 'bina_marga',
    component: BinaMarga
  },
  {
    path: '/sda',
    name: 'sda',
    component: Sda
  },
  {
    path: '/jasa_konstruksi',
    name: 'jasa_konstruksi',
    component: JasaKonstruksi
  },
  {
    path: '/tata_ruang',
    name: 'tata_ruang',
    component: TataRuang
  },
  {
    path: '/pengumuman',
    name: 'pengumuman',
    component: Pengumuman
  },
  {
    path: '/dokumen',
    name: 'dokumen',
    component: Dokumen
  },
  {
    path: '/foto',
    name: 'foto',
    component: Foto
  },
  {
    path: '/video',
    name: 'video',
    component: Video
  },
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
     }
  },
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
